import { Component } from '@angular/core';
import { CartItem } from 'app/models/cart-item.model';
import { ShoppingCart } from 'app/models/shopping-cart.model';
import { ShoppingCartService } from 'app/services/shopping-cart.service';
import { AppPage, AppPages } from 'app/state/app-page';
import { AppStateService } from 'app/state/app-state.service';
import { PageComponent } from '../PageComponent';

// Assume that all "global" licence change documents in Salesforce are named licence-changes-26-27 etc.
export const LICENCE_CHANGES = 'licence-changes-';
const LICENCE_CHANGES_DATES = /-(\d\d)-(\d\d)$/;

@Component({
  selector: 'dm-checkout',
  styleUrls: ['./checkout-page.component.scss'],
  templateUrl: './checkout-page.component.html',
})
export class CheckoutPageComponent extends PageComponent {
  page: AppPage = AppPages.checkout;
  nextPage: AppPage = AppPages.billingDetails;
  cart: ShoppingCart;
  cartItems: CartItem[] = [];
  itemCount: number = 0;
  licenceChangeUrls?: Set<string>;

  constructor(
    public appState: AppStateService,
    private readonly shoppingCartService: ShoppingCartService,
  ) {
    super();

    this.shoppingCartService.cart$.subscribe(cart => {
      this.cart = cart;
      this.itemCount = cart.items.length;
      this.cartItems = cart.items;
      this.licenceChangeUrls = this.cartItems
        .flatMap(i => i.product.licences)
        .map(l => l.eulaChangesUrl)
        .filter(url => url.substring(url.lastIndexOf('/') + 1).startsWith(LICENCE_CHANGES))
        .reduce((acc: Set<string>, changesUrl: string) => {
          acc.add(changesUrl);
          return acc;
        }, new Set());
      if (this.licenceChangeUrls.size === 0) {
        this.licenceChangeUrls = undefined;
      }
    });
  }

  /** Hack which will generate a formatted date range from the URL of a licence change document. */
  getLicenceChangeYears(url: string): string {
    const match = LICENCE_CHANGES_DATES.exec(url);
    return match && match.length === 3 ? `20${match[1]} - 20${match[2]}` : 'Unknown';
  }

  saveState() {
    this.shoppingCartService.stateChanged();
  }
}
